import React from "react";
import { getValue } from "@utils/lodash";

function MenuRepositorySvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath id="clip-path4">
            <rect
              id="Rectangle_18184"
              data-name="Rectangle 18184"
              width="24"
              height="24"
              transform="translate(-16198 -8067)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_292"
          data-name="Mask Group 292"
          transform="translate(16198 8067)"
          clipPath="url(#clip-path4)"
        >
          <path
            id="subscriptions_FILL0_wght300_GRAD0_opsz24"
            d="M5.061-6.866a1.825,1.825,0,0,1-1.35-.559,1.871,1.871,0,0,1-.553-1.367v-10a1.871,1.871,0,0,1,.553-1.367,1.825,1.825,0,0,1,1.35-.559H21.255a1.825,1.825,0,0,1,1.35.559,1.871,1.871,0,0,1,.553,1.367v10a1.871,1.871,0,0,1-.553,1.367,1.825,1.825,0,0,1-1.35.559Zm0-1.6H21.255a.308.308,0,0,0,.223-.1.315.315,0,0,0,.1-.225v-10a.315.315,0,0,0-.1-.225.308.308,0,0,0-.223-.1H5.061a.308.308,0,0,0-.223.1.315.315,0,0,0-.1.225v10a.315.315,0,0,0,.1.225A.308.308,0,0,0,5.061-8.465ZM5-22.194v-1.6H21.316v1.6Zm3.158-3.074v-1.6h10v1.6ZM4.737-8.465v0Z"
            transform="translate(-16199.158 -8038.134)"
            fill={
              getValue(props, `color`, "")
                ? getValue(props, `color`, "")
                : "#5f6368"
            }
          />
        </g>
      </svg>
    </div>
  );
}

export default MenuRepositorySvgComponent;
